import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { Text as Component } from './text';
import { sizes as configs } from './configs/desktop';
import styles from './styles/desktop.css';

export const TextDesktop = createWidget({
    configs,
    styles,
})(Component);
